import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import styles from './SwapPartnershipDisclosure.module.css';
export function SwapPartnershipDisclosure() {
    const { t } = useTranslation();
    return (_jsx("footer", { className: styles.footer, "data-testid": 'viewSwapPartnershipDisclosure', children: _jsx("p", { className: styles.text, children: t('benefits.emissor.swap-partnership.disclosure') }) }));
}
